export default __webpack_public_path__ + "static/media/sale__package__2cl.7c131702.png";